/* ==========================================================================
   Tooltip > Client > Popper
   ========================================================================== */

/* Modules */
const { createPopper } = require('@popperjs/core');

/* Init */
function initPopper(instance) {
    /* Trigger */
    const { trigger = false, placement, offset } = instance.config;

    if (!trigger) {
        return;
    }

    const panel = instance;

    /* Element */
    const { element } = instance;

    panel.popper = createPopper(trigger, element, {
        placement,
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset
                }
            }
        ]
    });
}

/* Destroy */
function destroyPopper(instance) {
    /* Trigger */
    const { trigger = false } = instance.config;

    if (!trigger) {
        return;
    }

    const panel = instance;

    instance.popper.destroy();
    delete panel.popper;
}

/* Exports */
module.exports = {
    initPopper,
    destroyPopper
};
